import { render, staticRenderFns } from "./procurement_procedure_protocol_declined.vue?vue&type=template&id=153a66f8"
import script from "./procurement_procedure_protocol_declined.vue?vue&type=script&lang=js"
export * from "./procurement_procedure_protocol_declined.vue?vue&type=script&lang=js"
import style0 from "./procurement_procedure_protocol_declined.vue?vue&type=style&index=0&id=153a66f8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports